.header {
    border-bottom: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

.body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.actions {
    border-top: 1px solid var(--mantine-color-ldGray-2);
    flex-shrink: 0;
}

/* Fullscreen mode */
.fullScreenContent.fullScreenContent {
    /* Mantine puts this class on the viewport-fixed inner AND the content,
       so size both at 100% — the 24px x/yOffset provides the even gutter.
       Doubled class beats Mantine's own auto-sizing content rule. */
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.fullScreenBody {
    flex: 1;
    min-height: 0;
    overflow: auto;
}
